import { useMediaQuery } from "react-responsive";
import { View, ViewProps } from "react-native";
import * as React from "react";

export const useSmallMobileMediaQuery = () => useMediaQuery({ maxWidth: 320 });

export const useMobileMediaQuery = () => useMediaQuery({ maxWidth: 767 });

export const useDesktopMediaQuery = () => useMediaQuery({ minWidth: 1025 });

export const useTabletMediaQuery = () =>
  useMediaQuery({
    minWidth: 768,
    maxWidth: 1024,
  });

interface ResposiveViewProps extends ViewProps {
  children: JSX.Element[] | JSX.Element;
}

export const DesktopView = (props: ResposiveViewProps) => {
  const { children } = props;
  const isDesktop = useDesktopMediaQuery();
  if (isDesktop) {
    return <View {...props}>{children}</View>;
  } else {
    return null;
  }
};

export const TabletView = (props: ResposiveViewProps) => {
  const { children } = props;
  const isTablet = useTabletMediaQuery();
  if (isTablet) {
    return <View {...props}>{children}</View>;
  }
  return null;
};

export const MobileView = (props: ResposiveViewProps) => {
  const { children } = props;
  const isMobile = useMobileMediaQuery();
  if (isMobile) {
    return <View {...props}>{children}</View>;
  }
  return null;
};
